import { Nullable } from '@types'

const CUSTOM_LABELS_MAP = {
  differentiator: 'status',
} as Record<string, string>

export const createPendoIdFromLabel = ({
  profileType,
  filterValue,
  parentValue,
  filterName: rawFilterName,
}: {
  profileType: string
  filterValue?: Nullable<string | number>
  parentValue?: string
  filterName: string
}) => {
  const filterName = CUSTOM_LABELS_MAP[rawFilterName] ?? rawFilterName
  const items = [profileType, filterName, parentValue, filterValue]

  const keys = items.filter(Boolean)

  if (!keys.length) {
    return ''
  }

  return keys
    .map(item => String(item)?.toLowerCase())
    .join('-')
    .replace(/[^a-z-0-9]/g, '')
}
